/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate } from "react-router-dom";
import ArrowLeftIcon from "@/assets/summary/arrow_left.svg?react";

export interface IHeaderProps {
  title: string;
  tip?: string;
  rightSlot?: React.ReactElement | null;
  backDisabled?: boolean;
}

const Header: React.FC<IHeaderProps> = ({ title, tip, rightSlot, backDisabled = false }) => {
  const navigate = useNavigate();

  const back = () => {
    navigate("/home");
  };

  return (
    <div className="px-6 py-2.25 h-16 flex items-center justify-between">
      <div className="flex items-center">
        {!backDisabled &&
          <ArrowLeftIcon
            className="w-6 h-6 mr-3 cursor-pointer"
            onClick={back}
          />
        }
        <div>
          <div className="text-4 color-#333 font-500 lh-6">{title}</div>
          {tip && <div className="text-3 color-#999 lh-6 mt--0.5">{tip}</div>}
        </div>
      </div>
      {rightSlot}
    </div>
  );
};

export default Header;
